var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 2.8C12.637 2.8 13.0555 2.8 13.3988 2.892C14.3306 3.14166 15.0583 3.86944 15.308 4.80119C15.4 5.14454 15.4 5.56303 15.4 6.4V14.68C15.4 16.1921 15.4 16.9482 15.1057 17.5258C14.8469 18.0338 14.4338 18.4469 13.9258 18.7057C13.3482 19 12.5921 19 11.08 19H5.32C3.80786 19 3.05179 19 2.47423 18.7057C1.96619 18.4469 1.55314 18.0338 1.29428 17.5258C1 16.9482 1 16.1921 1 14.68V6.4C1 5.56303 1 5.14454 1.092 4.80119C1.34166 3.86944 2.06944 3.14166 3.00119 2.892C3.34454 2.8 3.76303 2.8 4.6 2.8M5.5 12.7L7.3 14.5L11.35 10.45M6.04 4.6H10.36C10.864 4.6 11.1161 4.6 11.3086 4.50191C11.4779 4.41562 11.6156 4.27794 11.7019 4.10859C11.8 3.91607 11.8 3.66405 11.8 3.16V2.44C11.8 1.93595 11.8 1.68393 11.7019 1.49141C11.6156 1.32206 11.4779 1.18438 11.3086 1.09809C11.1161 1 10.864 1 10.36 1H6.04C5.53595 1 5.28393 1 5.09141 1.09809C4.92206 1.18438 4.78438 1.32206 4.69809 1.49141C4.6 1.68393 4.6 1.93595 4.6 2.44V3.16C4.6 3.66405 4.6 3.91607 4.69809 4.10859C4.78438 4.27794 4.92206 4.41562 5.09141 4.50191C5.28393 4.6 5.53595 4.6 6.04 4.6Z",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.6448004bb58075295dc16ccc34e5168b.svg";
export { ForwardRef as ReactComponent };